import React from 'react';
import LanguageToggle from './LanguageToggle';

/**
 * The signed-in admin's avatar, name, role and the language toggle beneath —
 * shared between the desktop sidebar footer and the phone nav drawer footer
 * (Ruling R10). Each caller passes its own class for the user-info row so
 * Task 6's separate `.sidebar-user` / `.nav-drawer-user` styling still
 * applies; the inner `sidebar-user-*` classes are identical in both and stay
 * as-is. Null-safe throughout: `admin` may not have loaded yet.
 */
const SidebarUser = ({ admin, userClassName = 'sidebar-user' }) => (
  <>
    <div className={userClassName}>
      <div className="sidebar-user-avatar">
        {admin?.name?.charAt(0).toUpperCase() || 'A'}
      </div>
      <div className="sidebar-user-info">
        <div className="sidebar-user-name">{admin?.name}</div>
        <div className="sidebar-user-role">
          {admin?.is_super_admin ? 'Super Admin' : 'Admin'}
        </div>
      </div>
    </div>
    <div style={{ marginTop: '0.75rem' }}>
      <LanguageToggle />
    </div>
  </>
);

export default SidebarUser;
